import Error from "../components/layout/error";
import ChangeAdvisor from "../pages/admin/changeAdvisor";
import CreateTeam from "../pages/admin/createTeam";
import CreateUser from "../pages/admin/createUser";
import Checklist from "../pages/Application/checklist";
import EditChecklist from "../pages/Application/editChecklist";
import Recommendation from "../pages/counsellor/recommendation";
import SuggestPackage from "../pages/counsellor/suggestPackage";
import CourseDetailed from "../pages/explore/courseDetailed";
import { AcademicFilter, Budget, CityFilter, LanguageFilter, StateFilter } from "../pages/explore/customFilters";
import MainPopup from "../pages/explore/mainPopup";
import UniversityDetailed from "../pages/explore/universityDetailed";

export const COMPONENTS = [
    {name:"addRecommendation",component:Recommendation},
    {name:"addChecklist",component:Checklist},
    {name:"editChecklist",component:EditChecklist},
    {name:"error",component:Error},
    {name:"suggested",component:SuggestPackage},
    {name:"state",component:StateFilter},
    {name:"city",component:CityFilter},
    {name:"budget",component:Budget},
    {name:"academicFilter",component:AcademicFilter},
    {name:"languageFilter",component:LanguageFilter},
    {name:"coursePopup",component:CourseDetailed},
    {name:"universityPopup",component:UniversityDetailed},
    {name:"mainPopup",component:MainPopup},
    {name:"crTeam",component:CreateTeam},
    {name:"changeAdvisor",component:ChangeAdvisor},
    {name:"crUser",component:CreateUser},


];

export const TEAM_ROLE_OPTIONS = [
  "processCoordinator",
  "developer",
  "counsellor",
  "remoteStudentAdvisor",
  "IEH_MEMBER",
];

export const counsellorstages = ["Counsellor Approved", "Counsellor Disapproved"];
export const processingStages = [
  "Request Received",
  "Document checklist",
  "Documents verification",
  "Application form draft",
  "Submission",
  "Pending Checklists",
  "Waiting for Decision",
  "Conditional Acceptance",
  "Result Received",
  "Financial Documents",
  "I20 Request",
  "I20 Received",
];
export const filterOptions = {
  coordinator: [
    {
      type: "stage",
      options: processingStages?.map((item) => ({
        name: item,
        value: item,
      })),
      selectedType: "multi",
      searchbox: false,
    },
    {
      type: "status",
      options: [
        { name: "Processing", value: "processing" },
        { name: "Accepted", value: "accepted" },
        { name: "Rejected", value: "rejected" },
        { name: "Cancelled", value: "cancelled" },
        { name: "Completed", value: "completed" },

      ],
      selectedType: "multi",
      searchbox: false,
    },
 
  ],

};
export const DestinationTypeEnum = {
  USA: "United States of America",
  UK: "United Kingdom",
  CN: "Canada",
  AUS: "Australia",
  IRL: "Ireland",
  NZ: "New Zealand",
  IN:"India"
}
export const CurrencySymbolEnum = {
    USD: "$",
    GBP: "£",
    CAD: "$",
    AUD: "AU$",
    EUR: "€",
    NZD: "$",
    INR: "₹",
}
export const countryList = [
  "Australia",
  "Canada",
  "United States of America",
  "United Kingdom",
  "New Zealand",
  "Ireland",
];

export const category = ["premium application", "elite application", "statement of purpose and letter of recommendation", "VISA process", "education loan process"]